<template>
  <v-app v-resize="onResize">
    <v-app-bar app>
      <v-container :fluid="$vuetify.breakpoint.mdAndDown">
        <v-row align="center" justify="center">
          <v-col class="flex-shrink-1 flex-grow-0">
            <!-- <v-avatar size="80"> -->
            <v-img :max-height="50" :max-width="250" contain :src="hkusph">
            </v-img>
            <!-- <pre class="mt-4 text-subtitle-2">
Confidential       Subject to Peer Review</pre
            > -->
            <!-- </v-avatar> -->
          </v-col>
          <!-- <v-col class="flex-shrink-1 flex-grow-0">
            <v-toolbar-title
              class="text-subtitle-1 font-weight-black text-uppercase text-center denser"
            >
              Life expectancy
              <br />and mortality
              <br />
              <span class="text-subtitle-2">Hong Kong</span>
            </v-toolbar-title>
          </v-col> -->
          <v-col class="flex-shrink-0 flex-grow-1 justify-end">
            <v-row v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>
              <v-btn small text :to="{ path: '/' }">Home</v-btn>
              <v-btn small text :to="{ path: '/life-expectancy' }">
                Life Expectancy Contributions
              </v-btn>
              <v-btn small text :to="{ path: '/tcal' }">Cohort survival</v-btn>
              <v-btn small text :to="{ path: '/smoking' }">Smoking</v-btn>
              <v-btn small text :to="{ path: '/migrants' }">
                Migrants in HK
              </v-btn>
              <!-- <v-menu offset-y open-on-hover>
                <template #activator="{on, attrs}">
                  <v-btn text v-bind="attrs" v-on="on">HK Focus</v-btn>
                </template>
                <v-list>
                  <v-list-item :to="{path: '/focus', hash: 'arriaga'}">
                    <v-list-item-title>Life Expectancy Contributions</v-list-item-title>
                  </v-list-item>
                  <v-list-item :to="{path: 'focus', hash: 'migrants'}">
                    <v-list-item-title>Migrants in HK</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>-->
              <!-- <v-btn text :to="{path: '/tcals', hash: 'tcals'}">TCALs</v-btn>
              <v-btn text :to="{path: '/smoking', hash: 'smoking'}">Smoking</v-btn>-->
              <!-- <v-menu offset-y open-on-hover>
                <template #activator="{on, attrs}">
                  <v-btn small text v-bind="attrs" v-on="on">Comparing HK</v-btn>
                </template>
                <v-list>
                  <v-list-item :to="{path: 'compare', hash: 'tcals'}">
                    <v-list-item-title>TCALs</v-list-item-title>
                  </v-list-item>
                  <v-list-item :to="{path: 'compare', hash: 'smoking'}">
                    <v-list-item-title>Smoking</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>-->
            </v-row>
            <v-row v-else>
              <v-spacer></v-spacer>
              <v-app-bar-nav-icon @click.stop="drawer = !drawer">
              </v-app-bar-nav-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed temporary right>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item :to="{ path: '/' }">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="{path: '/', hash: 'about'}">
            <v-list-item-title>About</v-list-item-title>
          </v-list-item>-->
          <!-- <v-list-group> -->
          <!-- <template #activator>
              <v-list-item-title>HK Focus</v-list-item-title>
          </template>-->
          <v-list-item :to="{ path: '/life-expectancy' }">
            <v-list-item-title>Life Expectancy Contributions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ path: '/tcal' }">
            <v-list-item-title>Cohort suvival</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ path: '/smoking' }">
            <v-list-item-title>Smoking</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ path: '/migrants' }">
            <v-list-item-title>Migrants in HK</v-list-item-title>
          </v-list-item>
          <!-- </v-list-group> -->

          <!-- <v-list-item :to="{path: '/focus', hash: 'smoking'}">
            <v-list-item-title>Smoking</v-list-item-title>
          </v-list-item>
          <v-list-group>
            <template #activator>
              <v-list-item-title>Comparing HK</v-list-item-title>
            </template>
            <v-list-item :to="{path: '/compare', hash: 'tcals'}">
              <v-list-item-title>TCALs</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{path: '/focus', hash: 'smoking'}">
              <v-list-item-title>Smoking</v-list-item-title>
            </v-list-item>
          </v-list-group>-->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <!-- <transition
        enter-active-class="animate__animated animate__bounceInLeft"
        leave-active-class="animate__animated animate__bounceOutRight"
        mode="out-in"
      > -->
      <router-view></router-view>
      <!-- </transition> -->
    </v-main>
    <v-footer fixed color="primary" dark app>
      <v-row justify="center" align="center" class="text-center text-caption">
        &copy;2021 - Hong Kong Life Expectancy
        <br />School of Public Health, The University of Hong Kong. All rights
        reserved.
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
// import Home from './components/Home';
import hkusph from "./assets/sph.png";

export default {
  name: "App",

  components: {
    // Home,
  },

  data: () => ({
    // windowSize: {
    //   x: 0,
    //   y: 0
    // },
    drawer: false,
    hkusph,
    //
  }),
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
  created() {
    this.onResize();
  },
};
</script>
<style scoped>
.denser {
  line-height: 1.3em !important;
}
</style>
<style lang="sass">
@import '../node_modules/typeface-roboto/index.css'
</style>
